/* MT/26 — cart page + cart drawer. Ajax cart API + Section Rendering API. Depends on mt-base.js (MT.money, MT.init). */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function q(s, sc) { return (sc || document).querySelector(s); }
  function qa(s, sc) { return Array.prototype.slice.call((sc || document).querySelectorAll(s)); }
  function money(c) { return (window.MT && MT.money) ? MT.money(c) : '$' + (c / 100).toFixed(2); }
  function initMT(scope) { if (window.MT && MT.init) MT.init(scope); }
  var pageSection = q('[data-mt-cart]');
  var drawer = q('[data-mt-cart-drawer]');
  var shade = q('.mt-cd-shade');
  var sectionIds = [];
  if (pageSection) sectionIds.push(pageSection.dataset.sectionId);
  if (drawer) sectionIds.push(drawer.dataset.sectionId);

  /* ---------- cart API ---------- */
  function api(path, body) {
    return fetch(root + 'cart/' + path + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(Object.assign({}, body, { sections: sectionIds.join(','), sections_url: location.pathname }))
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function rerender(sections) {
    if (!sections) return;
    [pageSection, drawer].forEach(function (sec) {
      if (!sec) return;
      var html = sections[sec.dataset.sectionId];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = sec === drawer ? q('[data-mt-cart-drawer]', doc) : q('[data-mt-cart]', doc);
      if (!fresh) return;
      // keep drawer open state + scroll position; keep toggles
      var scroll = q('[data-mt-cd-scroll]', sec); var scrollTop = scroll ? scroll.scrollTop : 0;
      var codeOpen = q('[data-mt-code-toggle]', sec) && q('[data-mt-code-toggle]', sec).getAttribute('aria-expanded') === 'true';
      var noteOpen = q('[data-mt-note-toggle]', sec) && q('[data-mt-note-toggle]', sec).getAttribute('aria-expanded') === 'true';
      var toastHidden = q('[data-mt-cd-toast]', sec) ? q('[data-mt-cd-toast]', sec).hidden : true;
      var toastText = q('[data-mt-cd-toast-text]', sec) ? q('[data-mt-cd-toast-text]', sec).textContent : '';
      var wasOpen = sec.classList.contains('mt-open');
      var focusMemo = rememberFocus(sec);
      var oldUpsell = q('[data-mt-upsell][data-loaded]', sec);   /* loaded recommendations survive a re-render for the same cart products (no refetch, no jump) */
      sec.innerHTML = fresh.innerHTML;
      if (wasOpen) sec.classList.add('mt-open');
      var s2 = q('[data-mt-cd-scroll]', sec); if (s2) s2.scrollTop = scrollTop;
      if (codeOpen) setToggle(q('[data-mt-code]', sec), true);
      if (noteOpen) setToggle(q('[data-mt-note]', sec), true);
      var t = q('[data-mt-cd-toast]', sec); if (t && !toastHidden) { t.hidden = false; q('[data-mt-cd-toast-text]', t).textContent = toastText; }
      initMT(sec);
      var newUpsell = q('[data-mt-upsell]', sec);
      if (oldUpsell && newUpsell && oldUpsell.dataset.mtIds === cartProfile(newUpsell).ids.slice(0, 2).join(',')) { newUpsell.parentNode.replaceChild(oldUpsell, newUpsell); matchUpsells(oldUpsell); }
      loadUpsells(sec);
      if (lockedNow) lockCheckout(true);   /* the fresh markup must not show an enabled Checkout while the ladder guard is on */
      restoreFocus(sec, focusMemo);
    });
    checkCart();
  }
  /* header cart count (Symmetry + ours) + discount chips + ladder guard, all from the real cart state; the promise is
     kept so a Checkout submitted before the check lands can wait for it */
  var cartCheck = null;
  function checkCart() {
    var p = fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      qa('.cart-count, .header__cart-count, [data-mt-header-count], .js-cart-count').forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
      renderAppliedCode(document, cart); guardCheckout(cart);
      document.dispatchEvent(new CustomEvent('mt:cart:updated', { detail: cart }));
    }).catch(function () {}).then(function () { if (cartCheck === p) cartCheck = null; });
    cartCheck = p; return p;
  }
  /* ---------- keyboard focus survives a re-render (WCAG 2.4.3): remember the active control, find its equivalent in the fresh markup ---------- */
  var FOCUS_ACTIONS = ['data-mt-qty-minus', 'data-mt-qty-plus', 'data-mt-qty-input', 'data-mt-remove', 'data-mt-size-toggle', 'data-mt-size-pick', 'data-mt-upsell-add', 'data-mt-upsell-prev', 'data-mt-upsell-next', 'data-mt-code-toggle', 'data-mt-code-input', 'data-mt-code-apply', 'data-mt-code-remove', 'data-mt-note-toggle', 'data-mt-note-input', 'data-mt-cd-close'];
  function rememberFocus(sec) {
    var a = document.activeElement;
    if (!a || a === document.body || !sec.contains(a)) return null;
    var memo = { action: null, key: null, upsell: null, index: 0 };
    FOCUS_ACTIONS.forEach(function (n) { if (!memo.action && a.hasAttribute(n)) memo.action = n; });
    var line = a.closest('[data-mt-line]'); if (line) memo.key = line.dataset.key;
    var card = a.closest('[data-mt-upsell-card]'); if (card) memo.upsell = card.dataset.productId;
    if (!memo.action) memo.index = qa('a[href], button, input, select, textarea', sec).indexOf(a);
    return memo;
  }
  function restoreFocus(sec, memo) {
    if (!memo) return;
    var scope = sec, target = null;
    if (memo.key) scope = q('[data-mt-line][data-key="' + memo.key + '"]', sec);
    if (memo.upsell) scope = q('[data-mt-upsell-card][data-product-id="' + memo.upsell + '"]', sec);
    if (scope && memo.action) target = q('[' + (memo.action === 'data-mt-size-pick' ? 'data-mt-size-toggle' : memo.action) + ']', scope);
    if (!target && memo.key && !scope) target = q('[data-mt-line] [data-mt-qty-plus], [data-mt-line] [data-mt-remove]', sec);   /* that line is gone: next line */
    if (!target && !memo.action) { var all = qa('a[href], button, input, select, textarea', sec); target = all[Math.max(0, Math.min(memo.index, all.length - 1))]; }
    if (!target) target = q('.mt-cd__title, h1, h2', sec);
    if (!target) target = q('a[href], button, input, select, textarea', sec);
    if (!target) return;
    if (!/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName) && !target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }
  function busy(on) { qa('[data-mt-lines]').forEach(function (l) { l.classList.toggle('mt-busy', on); }); }
  function change(body) { busy(true); return api('change', body).then(function (j) { rerender(j.sections); return j; }).catch(function (e) { busy(false); toast(e && e.description || 'Could not update cart', true); throw e; }); }
  function add(items, opts) {
    opts = opts || {};
    return api('add', { items: items }).then(function (j) {
      rerender(j.sections);
      var title = j.items && j.items[0] ? j.items[0].product_title : (j.product_title || '');
      if (drawer && drawer.dataset.openOnAdd !== 'false' && !opts.silent) { openDrawer(); toast('Added to cart — ' + title); }
      return j;
    }).catch(function (e) { toast(e && e.description || 'Could not add to cart', true); throw e; });
  }
  function toast(text, isErr) {
    var t = drawer && q('[data-mt-cd-toast]', drawer); if (!t) return;
    t.hidden = false; t.style.background = isErr ? '#BF570A' : '';
    var tt = q('[data-mt-cd-toast-text]', t); tt.textContent = ''; setTimeout(function () { tt.textContent = text; }, 30);   /* role="status": the text changes after the region is visible */
    clearTimeout(t._h); t._h = setTimeout(function () { t.hidden = true; }, 3500);
  }

  /* ---------- drawer open/close ---------- */
  var lastFocus;
  function openDrawer() {
    if (!drawer) return;
    if (!drawer.classList.contains('mt-open')) lastFocus = document.activeElement;
    drawer.classList.add('mt-open'); if (shade) shade.classList.add('mt-open'); document.body.classList.add('mt-cd-locked');
    if (window.MT && MT.trapFocus) MT.trapFocus(drawer, { initial: drawer, opener: lastFocus, delay: 50 });   /* Tab stays inside the dialog (WCAG 2.4.3) */
    else setTimeout(function () { drawer.focus(); }, 50);
    loadUpsells(drawer);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('mt-open'); if (shade) shade.classList.remove('mt-open'); document.body.classList.remove('mt-cd-locked');
    var t = q('[data-mt-cd-toast]', drawer); if (t) t.hidden = true;
    if (window.MT && MT.releaseFocus) MT.releaseFocus(drawer, { noReturn: true });
    var back = lastFocus;
    if (!(back && back.focus && document.contains(back) && (back.offsetWidth || back.offsetHeight))) back = document.querySelector('[data-mt-cart-open]');   /* opener gone (e.g. quick view closed): the header cart button */
    if (back && back.focus) back.focus();
  }
  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    return fetch(location.pathname + '?section_id=' + drawer.dataset.sectionId).then(function (r) { return r.text(); }).then(function (html) { var o = {}; o[drawer.dataset.sectionId] = html; rerender(o); });
  }
  window.MT = window.MT || {};
  MT.openCart = function () { refreshDrawer().then(openDrawer); };
  MT.closeCart = closeDrawer;
  MT.cartAdd = add;
  // theme + app hooks
  document.addEventListener('on:cart:add', function () { if (drawer && drawer.dataset.openOnAdd !== 'false') MT.openCart(); });
  document.addEventListener('dispatch-cart-drawer:open', MT.openCart);
  document.addEventListener('dispatch:cart-drawer:open', MT.openCart);
  var refreshAt = 0;
  document.addEventListener('dispatch:cart-drawer:refresh', function () { refreshAt = Date.now(); if (pageSection) refreshAll(); else refreshDrawer(); });   /* promo engine applies a ladder code: on /cart re-render the page summary too */
  document.addEventListener('dispatch:cart-drawer:close', closeDrawer);
  document.addEventListener('mt:open-cart', MT.openCart);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href$="/cart"], a[href="' + root + 'cart"], [data-mt-cart-open], .js-cart-drawer-open, .header__cart-link, a.cart-link');
    if (a && drawer && !e.target.closest('[data-mt-cart]') && !a.closest('.mt-cd')) { e.preventDefault(); MT.openCart(); }
    if (e.target.closest('[data-mt-cd-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && drawer.classList.contains('mt-open')) closeDrawer(); });
  // swipe down to close (mobile sheet)
  if (drawer) {
    var y0 = null;
    drawer.addEventListener('touchstart', function (e) { var sc = q('[data-mt-cd-scroll]', drawer); if (!sc || sc.scrollTop <= 0) y0 = e.touches[0].clientY; }, { passive: true });
    drawer.addEventListener('touchmove', function (e) { if (y0 !== null && e.touches[0].clientY - y0 > 90) { y0 = null; closeDrawer(); } }, { passive: true });
    drawer.addEventListener('touchend', function () { y0 = null; });
  }

  /* ---------- line actions (delegated; works after rerender) ---------- */
  var qtyTimer = {};
  document.addEventListener('click', function (e) {
    var line = e.target.closest('[data-mt-line]'); var key = line && line.dataset.key;
    var minus = e.target.closest('[data-mt-qty-minus]'), plus = e.target.closest('[data-mt-qty-plus]');
    if (line && (minus || plus)) {
      var inp = q('[data-mt-qty-input]', line); var v = Math.max(0, (parseInt(inp.value, 10) || 0) + (plus ? 1 : -1));
      inp.value = v; scheduleQty(line, key, v); return;
    }
    if (line && e.target.closest('[data-mt-remove]')) { line.classList.add('mt-removing'); setTimeout(function () { change({ id: key, quantity: 0 }); }, 250); return; }
    var st = e.target.closest('[data-mt-size-toggle]');
    if (line && st) { var sizes = q('[data-mt-sizes]', line); var cta = q('[data-mt-size-cta]', line); sizes.hidden = !sizes.hidden; st.setAttribute('aria-expanded', sizes.hidden ? 'false' : 'true'); if (cta) cta.textContent = sizes.hidden ? 'Change size' : 'Close'; return; }
    var pick = e.target.closest('[data-mt-size-pick]');
    if (line && pick) {
      var newId = parseInt(pick.dataset.mtSizePick, 10), qty = parseInt(q('[data-mt-qty-input]', line).value, 10) || 1;
      var oldId = parseInt(line.dataset.variantId, 10);
      var props = {}; try { props = JSON.parse(line.dataset.props || '{}') || {}; } catch (e0) {}
      // optimistic UI: show the new size right away, collapse the picker
      var lbl = q('.mt-cl__variant > span', line); if (lbl) lbl.textContent = lbl.textContent.replace(/[^·]*$/, ' ' + pick.textContent.trim()).replace(/^\s+/, '');
      qa('.mt-cl__size', line).forEach(function (b) { b.classList.toggle('mt-on', b === pick); b.setAttribute('aria-pressed', b === pick ? 'true' : 'false'); });
      var sizesEl = q('[data-mt-sizes]', line); if (sizesEl) sizesEl.hidden = true; var ctaEl = q('[data-mt-size-cta]', line); if (ctaEl) ctaEl.textContent = 'Change size';
      line.classList.add('mt-busy');
      var swap;
      if (Object.keys(props).length) {
        swap = api('change', { id: key, quantity: 0 }).then(function () { return api('add', { items: [{ id: newId, quantity: qty, properties: props }] }); });
      } else {
        var updates = {}; updates[oldId] = 0; updates[newId] = qty;
        swap = api('update', { updates: updates });
      }
      swap.then(function (j2) { rerender(j2.sections); toast('Size updated'); }).catch(function (e2) { line.classList.remove('mt-busy'); toast(e2 && e2.description || 'Could not change size', true); refreshAll(); });
      return;
    }
    var up = e.target.closest('[data-mt-upsell-add]');
    if (up) { up.classList.add('mt-loading'); add([{ id: parseInt(up.dataset.mtUpsellAdd, 10), quantity: 1 }], { silent: !!e.target.closest('.mt-cd') }).then(function () { up.classList.remove('mt-loading'); }).catch(function () { up.classList.remove('mt-loading'); }); return; }
    var ct = e.target.closest('[data-mt-code-toggle]'); if (ct) { setToggle(ct.closest('[data-mt-code]'), ct.getAttribute('aria-expanded') !== 'true'); return; }
    var nt = e.target.closest('[data-mt-note-toggle]'); if (nt) { setToggle(nt.closest('[data-mt-note]'), nt.getAttribute('aria-expanded') !== 'true'); return; }
    var ap = e.target.closest('[data-mt-code-apply]'); if (ap) { applyCode(ap.closest('[data-mt-code]')); return; }
    var rc = e.target.closest('[data-mt-code-remove]'); if (rc) { removeCode(rc.closest('[data-mt-code]'), rc.dataset.mtCodeRemove); return; }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-mt-qty-input]')) { var line = e.target.closest('[data-mt-line]'); scheduleQty(line, line.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0)); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-mt-code-input]')) { e.preventDefault(); applyCode(e.target.closest('[data-mt-code]')); } });
  function scheduleQty(line, key, v) { clearTimeout(qtyTimer[key]); line.classList.add('mt-busy'); qtyTimer[key] = setTimeout(function () { change({ id: key, quantity: v }); }, 220); }
  function setToggle(wrap, open) {
    if (!wrap) return;
    var btn = q('[aria-expanded]', wrap), body = q('.mt-code__body, .mt-note__body', wrap);
    btn.setAttribute('aria-expanded', open); body.hidden = !open; var i = q('i', btn); if (i) i.textContent = open ? '−' : '+';
    if (open) { var inp = q('input, textarea', body); if (inp) setTimeout(function () { inp.focus(); }, 30); }
  }

  /* ---------- order note (autosave) ---------- */
  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-mt-note-input]')) return;
    var wrap = e.target.closest('[data-mt-note]'); var len = q('[data-mt-note-len]', wrap); if (len) len.textContent = e.target.value.length;
    var saved = q('[data-mt-note-saved]', wrap); if (saved) saved.hidden = true;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: e.target.value }) }).then(function () { if (saved) saved.hidden = false; });
    }, 700);
  });

  /* ---------- discount codes ----------
     Source of truth is the cart itself (cart.js discount_codes), never localStorage: a chip is shown only for a code
     that is really on the cart right now. Codes are written with /cart/update.js { discount } (Ajax Cart API, May 2025),
     which replaces the whole set, so the current codes are always re-sent together with the new one. Ladder codes
     (LAYER10/LAYER15, retired ones) belong to the promo engine: they are never shown as chips and never removable here. */
  function promoCfg() {
    var raw = window.MT_PROMO || window.MT_PROMO_DEFAULT; if (!raw) return null;
    if (typeof raw === 'string') { try { raw = JSON.parse(raw); } catch (e) { return null; } }
    if (!raw || raw.enabled === false || !Array.isArray(raw.tiers)) return null;
    var now = Date.now(), from = raw.starts_at ? Date.parse(raw.starts_at) : NaN, to = raw.ends_at ? Date.parse(raw.ends_at) : NaN;
    if (!isNaN(from) && now < from) return null;
    if (!isNaN(to) && now >= to) return null;
    var tiers = raw.tiers.map(function (t) { return { min: Math.round(Number(t && t.min)) || 0, code: String((t && t.code) || '').trim().toUpperCase() }; })
      .filter(function (t) { return t.min > 0 && t.code; }).sort(function (a, b) { return a.min - b.min; });
    var ladder = tiers.map(function (t) { return t.code; }).concat((Array.isArray(raw.retired_codes) ? raw.retired_codes : []).map(function (c) { return String(c).trim().toUpperCase(); }));
    return { tiers: tiers, ladder: ladder };
  }
  function isLadderCode(code) { var cfg = promoCfg(); return !!cfg && cfg.ladder.indexOf(code) !== -1; }
  function cartCodes(cart) {
    return ((cart && cart.discount_codes) || []).filter(function (d) { return d && d.code && String(d.code).toUpperCase() !== 'CLEAR'; })
      .map(function (d) { return { code: String(d.code).toUpperCase(), ok: d.applicable !== false }; });
  }
  function writeCodes(list) { return api('update', { discount: list.join(',') }); }
  function applyCode(wrap) {
    var inp = q('[data-mt-code-input]', wrap), btn = q('[data-mt-code-apply]', wrap), err = q('[data-mt-code-err]', wrap), field = q('.mt-code__field', wrap);
    var sec = wrap.closest('[data-mt-cart], [data-mt-cart-drawer]');
    var code = (inp.value || '').trim().toUpperCase(); if (!code) return;
    btn.classList.add('mt-loading'); err.hidden = true; field.classList.remove('mt-err');
    function fail(sections) {   /* after a re-render the field is fresh markup: show the error there, keep the code in the input */
      if (sections) rerender(sections);
      var w = (sec && q('[data-mt-code]', sec)) || wrap; setToggle(w, true);
      var i2 = q('[data-mt-code-input]', w), b2 = q('[data-mt-code-apply]', w), e2 = q('[data-mt-code-err]', w), f2 = q('.mt-code__field', w);
      if (i2) i2.value = code; if (b2) b2.classList.remove('mt-loading'); if (e2) e2.hidden = false; if (f2) f2.classList.add('mt-err');
    }
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var keep = cartCodes(cart).filter(function (c) { return c.ok && c.code !== code; }).map(function (c) { return c.code; });
      return writeCodes(keep.concat([code])).then(function (next) {
        var hit = cartCodes(next).filter(function (c) { return c.code === code; })[0];
        if (!hit || !hit.ok) {
          // Shopify keeps an unknown or non-applicable code on the cart with applicable:false — drop it again and tell the shopper
          return writeCodes(keep).then(function (back) { fail(back.sections); });
        }
        btn.classList.remove('mt-loading'); inp.value = ''; rerender(next.sections);
      });
    }).catch(function () { fail(null); });
  }
  function removeCode(wrap, code) {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var keep = cartCodes(cart).filter(function (c) { return c.ok && c.code !== code; }).map(function (c) { return c.code; });
      return writeCodes(keep).then(function (next) { rerender(next.sections); });
    }).catch(function () { if (pageSection) refreshAll(); else refreshDrawer(); });
  }
  function renderAppliedCode(scope, cart) {
    var codes = cartCodes(cart || {}).filter(function (c) { return c.ok && !isLadderCode(c.code); });
    qa('[data-mt-code]', scope).forEach(function (wrap) {
      var box = q('[data-mt-code-applied]', wrap); if (!box) return;
      box.innerHTML = ''; box.hidden = codes.length === 0;
      codes.forEach(function (c) {
        var d = document.createElement('div'); d.className = 'mt-code__chip';
        d.innerHTML = '<span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' + c.code + '</span><button type="button" data-mt-code-remove="' + c.code + '" aria-label="Remove code"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
        box.appendChild(d);
      });
      if (codes.length) setToggle(wrap, true);
    });
  }

  /* ---------- ladder guard ----------
     The promo engine (mt-promo.js) applies LAYER codes by itself about a second after the cart changes. The drawer is
     faster than that, so a shopper could reach checkout before the code lands. While the cart qualifies for a ladder
     code that is not on it yet, the Checkout buttons wait with "Applying your discount…" and the cart is polled; the
     lock is released as soon as the code is there, and never held longer than 7 s for the same cart (if the engine
     cannot apply the code — inactive discount, a foreign code — the sale must not be blocked). */
  function ladderPending(cart) {
    var cfg = promoCfg(); if (!cfg || !cart || !cart.item_count) return false;
    var base = cart.items_subtotal_price || 0;
    (cart.items || []).forEach(function (it) { if ((it.properties && it.properties._mt_gift) || it.gift_card) base -= it.final_line_price || 0; });
    var want = ''; cfg.tiers.forEach(function (t) { if (base >= t.min) want = t.code; });
    if (!want) return false;
    var applied = cartCodes(cart).filter(function (c) { return c.ok; }).map(function (c) { return c.code; });
    if (applied.some(function (c) { return cfg.ladder.indexOf(c) === -1; })) return false;   // a foreign code: the engine leaves it alone
    return applied.indexOf(want) === -1;
  }
  var guardTimer = null, guardKey = '', guardStart = 0, lockedNow = false;
  function checkoutButtons() { return qa('.mt-cd__checkout, .mt-summary__checkout'); }
  function lockCheckout(on) {
    lockedNow = !!on;
    checkoutButtons().forEach(function (b) {
      if (on) { if (!b.dataset.mtLabel) { b.dataset.mtLabel = b.innerHTML; b.innerHTML = 'Applying your discount…'; } b.disabled = true; b.classList.add('mt-wait'); b.setAttribute('aria-busy', 'true'); }
      else if (b.dataset.mtLabel) { b.innerHTML = b.dataset.mtLabel; delete b.dataset.mtLabel; b.disabled = false; b.classList.remove('mt-wait'); b.removeAttribute('aria-busy'); }
    });
  }
  function guardCheckout(cart) {
    clearTimeout(guardTimer);
    if (!ladderPending(cart)) { lockCheckout(false); guardKey = ''; return; }
    var key = (cart.items_subtotal_price || 0) + '|' + (cart.item_count || 0);
    if (key !== guardKey) { guardKey = key; guardStart = Date.now(); }
    if (Date.now() - guardStart > 7000) { lockCheckout(false); return; }
    lockCheckout(true);
    guardTimer = setTimeout(function () {
      fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        if (ladderPending(c) && Date.now() - guardStart <= 7000) { guardCheckout(c); return; }
        guardKey = '';
        if (!totalsStale(c)) { lockCheckout(false); return; }
        /* the code is on the cart but the totals on screen are old. The engine's own refresh event follows within
           ~0.5 s (it waits for the /discount redirect to load), and that re-render unlocks the buttons; re-render here
           only if it does not come, so the drawer is not redrawn twice */
        var seen = refreshAt;
        guardTimer = setTimeout(function () { if (refreshAt === seen) (pageSection ? refreshAll() : refreshDrawer()).catch(function () { lockCheckout(false); }); }, 1200);
      }).catch(function () { lockCheckout(false); });
    }, 450);
  }
  function totalsStale(cart) {
    var el = q('[data-mt-total]'); if (!el) return true;
    return (el.textContent || '').replace(/[^0-9]/g, '') !== String(cart.total_price || 0);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.matches || !f.matches('form[action$="/cart"], form[action*="/cart?"], #MTCartForm')) return;
    if (e.submitter && e.submitter.name && e.submitter.name !== 'checkout') return;   /* not a Checkout submit */
    if (checkoutButtons().some(function (b) { return b.disabled; })) { e.preventDefault(); return; }
    if (cartCheck) {   /* the cart just changed and its state is still being read: let the check finish, then go to checkout */
      e.preventDefault();
      cartCheck.then(function () { if (!checkoutButtons().some(function (b) { return b.disabled; })) location.href = root + 'checkout'; });
    }
  }, true);
  function refreshAll() {
    var url = location.pathname + '?sections=' + sectionIds.join(',');
    return fetch(url).then(function (r) { return r.json(); }).then(rerender);
  }

  /* ---------- upsells: complementary recs for the first two cart products, matched to the size/colour in the cart ---------- */
  function cartProfile(scope) {
    var lines = qa('[data-mt-line]', scope.closest ? (scope.closest('[data-mt-cart], [data-mt-cart-drawer]') || scope) : scope);
    if (!lines.length) lines = qa('[data-mt-line]');
    var prof = { size: null, color: null, ids: [] };
    lines.forEach(function (l) {
      try {
        var names = JSON.parse(l.dataset.options || '[]'), opts = JSON.parse(l.dataset.opts || '[]');
        names.forEach(function (n, i) { var k = String(n).toLowerCase(); if (k === 'size' && !prof.size) prof.size = opts[i]; if (/colou?r/.test(k) && !prof.color) prof.color = opts[i]; });
      } catch (e) {}
      if (l.dataset.productId && prof.ids.indexOf(l.dataset.productId) === -1) prof.ids.push(l.dataset.productId);
    });
    return prof;
  }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function matchUpsells(el) {
    var prof = cartProfile(el), grid = q('[data-mt-upsell-grid]', el); if (!grid) return;
    var matched = 0, total = 0;
    qa('[data-mt-upsell-card]', grid).forEach(function (card) {
      var names, vars; try { names = JSON.parse(card.dataset.options || '[]'); vars = JSON.parse(card.dataset.variants || '[]'); } catch (e) { return; }
      total++;
      if (prof.ids.indexOf(card.dataset.productId) !== -1) { card.hidden = true; return; }
      var si = -1, ci = -1; names.forEach(function (n, i) { var k = String(n).toLowerCase(); if (k === 'size') si = i; if (/colou?r/.test(k)) ci = i; });
      var pick = null, sizeOk = false;
      if (si > -1 && prof.size) {
        var bySize = vars.filter(function (v) { return v.available && norm(v.opts[si]) === norm(prof.size); });
        if (bySize.length) { sizeOk = true; pick = bySize.find(function (v) { return ci > -1 && prof.color && norm(v.opts[ci]) === norm(prof.color); }) || bySize[0]; }
      }
      if (!pick) pick = vars.find(function (v) { return v.available; }) || vars[0];
      if (!pick) { card.hidden = true; return; }
      var btn = q('[data-mt-upsell-add]', card); if (btn) btn.dataset.mtUpsellAdd = pick.id;
      var pr = q('[data-mt-upsell-price]', card); if (pr) pr.textContent = money(pick.price);
      var vl = q('[data-mt-upsell-variant]', card);
      if (vl) { vl.textContent = names.length && pick.title !== 'Default Title' ? pick.title : 'One size'; if (sizeOk) { vl.insertAdjacentHTML('afterbegin', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'); } }
      card.classList.toggle('mt-upsell--matched', sizeOk);
      if (sizeOk) { matched++; grid.insertBefore(card, grid.firstChild); }
    });
    var sub = q('[data-mt-upsell-sub]', el);
    if (sub) sub.textContent = prof.size ? 'Picked to match your cart · size ' + prof.size + (prof.color ? ', ' + prof.color : '') : '';
    var visible = qa('[data-mt-upsell-card]:not([hidden])', grid).length;
    if (!visible) el.hidden = true; else el.hidden = false;
    var nav = q('.mt-upsell-nav', el); if (nav) nav.hidden = visible < 2;
  }
  function loadUpsells(scope) {
    qa('[data-mt-upsell]', scope).forEach(function (el) {
      if (el.dataset.loaded || !el.dataset.url || el.dataset.url.indexOf('product_id=&') > -1) { if (!el.dataset.loaded) matchUpsells(el); return; }
      el.dataset.loaded = '1';
      var prof = cartProfile(el), mine = q('[data-mt-upsell-grid]', el);
      el.dataset.mtIds = prof.ids.slice(0, 2).join(',');
      var urls = prof.ids.slice(0, 2).map(function (id) { return el.dataset.url.replace(/product_id=\d*/, 'product_id=' + id); });
      if (!urls.length) urls = [el.dataset.url];
      Promise.all(urls.map(function (u) { return fetch(u).then(function (r) { return r.text(); }).catch(function () { return ''; }); })).then(function (htmls) {
        var seen = {}, cards = [];
        htmls.forEach(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          qa('[data-mt-upsell-card]', doc).forEach(function (c) { var id = c.dataset.productId; if (!seen[id]) { seen[id] = 1; cards.push(c); } });
        });
        if (cards.length && mine) { mine.innerHTML = ''; cards.forEach(function (c) { mine.appendChild(c); }); initMT(mine); }
        matchUpsells(el);
      });
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mt-upsell-prev], [data-mt-upsell-next]'); if (!b) return;
    var el = b.closest('[data-mt-upsell]'), grid = el && q('[data-mt-upsell-grid]', el); if (!grid) return;
    var card = q('[data-mt-upsell-card]:not([hidden])', grid); var step = card ? card.getBoundingClientRect().width + 12 : 300;
    grid.scrollBy({ left: b.hasAttribute('data-mt-upsell-next') ? step : -step, behavior: 'smooth' });
  });

  /* ---------- boot ---------- */
  function boot() {
    try { localStorage.removeItem('mt-codes'); } catch (e) {}
    var waitCss = document.createElement('style'); waitCss.textContent = '.mt-cd__checkout.mt-wait,.mt-summary__checkout.mt-wait,.mt-cd__checkout.mt-wait:hover,.mt-summary__checkout.mt-wait:hover{background:#8B877F!important;cursor:wait}'; document.head.appendChild(waitCss);
    loadUpsells(document);
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) { renderAppliedCode(document, cart); guardCheckout(cart); }).catch(function () {});
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer.previousElementSibling && drawer.previousElementSibling.classList.contains('mt-cd-shade') ? drawer.previousElementSibling : shade || document.createElement('span'));
    if (drawer && drawer.parentNode !== document.body) document.body.appendChild(drawer);
    if (drawer && drawer.dataset.mtAutoopen) MT.openCart();
    // Shopify theme editor: open drawer when its section is selected
    document.addEventListener('shopify:section:select', function (e) { if (e.target.contains(drawer)) openDrawer(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.contains(drawer)) closeDrawer(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
